export default __webpack_public_path__ + "static/media/investment.2f1e4f1f.svg";